import { useState } from "react";
import Container from "../components/layout/Container";
import PageHeader from "../components/layout/PageHeader";
import Button from "../components/ui/Button";
import SocialLinks from "../components/ui/SocialLinks";
import { contact, profile } from "../data/site";

export default function ContactPage() {
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    setLoading(true);

    try {
      const response = await fetch(contact.endpoint, {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" },
      });
      setStatus(response.ok ? "success" : "error");
      if (response.ok) form.reset();
    } catch {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHeader title="Contact" lede={contact.lede} />
      <Container className="pb-24">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a
              className="text-lg text-[var(--ink)] underline decoration-[var(--line-strong)] underline-offset-4 hover:decoration-[var(--ink)]"
              href={`mailto:${profile.email}`}
            >
              {profile.email}
            </a>
            <div className="mt-8">
              <SocialLinks labeled />
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5 lg:col-span-6 lg:col-start-7">
            <div>
              <label htmlFor="name" className="mb-1.5 block text-sm font-medium">
                Name
              </label>
              <input className="field" id="name" name="name" type="text" autoComplete="name" required />
            </div>
            <div>
              <label htmlFor="email" className="mb-1.5 block text-sm font-medium">
                Email
              </label>
              <input className="field" id="email" name="email" type="email" autoComplete="email" required />
            </div>
            <div>
              <label htmlFor="subject" className="mb-1.5 block text-sm font-medium">
                Subject
              </label>
              <input className="field" id="subject" name="subject" type="text" required />
            </div>
            <div>
              <label htmlFor="message" className="mb-1.5 block text-sm font-medium">
                Message
              </label>
              <textarea className="field resize-y" id="message" name="message" rows="6" required />
            </div>
            <Button type="submit" disabled={loading}>
              {loading ? "Sending…" : "Send message"}
            </Button>
            {status ? (
              <p
                className="text-sm"
                role="status"
                style={{ color: status === "success" ? "var(--ink)" : "#b42318" }}
              >
                {status === "success"
                  ? "Message sent. I will reply by email."
                  : "The message could not be sent. Please try again, or use email."}
              </p>
            ) : null}
          </form>
        </div>
      </Container>
    </>
  );
}
